import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchDeliveryArticleCategories } from '../../api/fetch-delivery-article-categories';

export const fetchDeliveryArticleCategoriesThunk = createAsyncThunk(
    'fetchDeliveryArticleCategories',
    async () => fetchDeliveryArticleCategories(),
);
